import React, { useState, useEffect, useRef } from 'react'
import PmModuleStyle from '../styles/pm.module.css';
import info from '../assets/info.png';

const CalProfitLoss = ({ simObj, setSimObj, pmPopup, setPmPopup,costParameters}) => {
  const [isToggled, setIsToggled] = useState(false);
  const popupRef = useRef(null);
  const buttonRef = useRef(null);
  const profitPerformanceValue = simObj?.laststate?.profitPerformanceValue;
  const projectedProjectCost = costParameters?.projectCost ?  costParameters?.projectCost : 0;
  const constructionBudget = simObj?.laststate?.constructionBudget;
  const handleToggle = (event) => {
    if(event === undefined){
      return;
    }
    setIsToggled((prev) => {
    const next = !prev;
    // Focus popup when it opens
    if (!prev) {
      setTimeout(() => popupRef.current?.focus(), 150);
    }
    return next;
    });
  };
  
  const handleKeyDown = (event) => {
   if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      
      // Toggle the popup
      setIsToggled((prev) => {
        const next = !prev;
        // Focus popup when it opens
        if (!prev) {
          setTimeout(() => popupRef.current?.focus(), 150);
        }
        // If the popup is closing, set focus back to the info icon
        if (prev) {
          setTimeout(() => buttonRef.current?.focus(), 100);
        }
        return next;
      });
      
    } else if (event.key === "Escape") {
      // Close popup when pressing Escape
      setIsToggled(false);
      setTimeout(() => buttonRef.current?.focus(), 100); // Return focus to the info icon
    } else if (event.key === "Tab") {
      setIsToggled(false);
    }
  };
//   window.$(document).on("click", function(e){
//     if(!window.$(e.target).closest('#detailsProfit').length > 0){
//       setIsToggled(false);
//     }
//  })
  const progressbar = {
    valuemin: -20000,
    valuemax: 70000,
    valuenow: function () {
      let projectedProfitValue = costParameters?.projectProfit ?  costParameters?.projectProfit : 0;
      // Ensure the projectedProfitValue is within the range of valuemin and valuemax
      projectedProfitValue = Math.max(this.valuemin, Math.min(this.valuemax, projectedProfitValue));
      // Calculate the progress percentage
      const progressPercentage = (projectedProfitValue - this.valuemin) / (this.valuemax - this.valuemin) * 100;
      return Math.ceil(progressPercentage);
    },
  };
  
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }

  useEffect(() => {
    const handleClickOutside  = (e) => {
      const button = buttonRef.current;
      const popup = popupRef.current;
      if (
        popup &&
        !popup.contains(e.target) &&
        button &&
        !button.contains(e.target)
      ) {
        setIsToggled(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (

    <div className={`${PmModuleStyle["pl-progress"]}`} id="progressed-goal" >

      <div className={`${PmModuleStyle["pl-progress-child"]}`} >
        <div className={`${PmModuleStyle["projected-cost"]}`} id="ProjectProfit">
         
          <div className={`${PmModuleStyle['title-icon-div']}`}>
            <h3 className={`${PmModuleStyle["pl-header"]}`}>Project Profit</h3>
            <a id={`${PmModuleStyle.detailsProfit}`} ref={buttonRef} href="javascript:void(0)" role="button" aria-label="Info about Project Profit" onClick={handleToggle}
            onKeyDown={handleKeyDown}
            // onMouseEnter={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggled(true);
            //   }
            // }}
            // onMouseLeave={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggled(false);
            //   }
            // }}
            // onBlur={()=> setIsToggled(false)}
            ><img src={info} alt="" aria-hidden="true" role="presentation" width={18} /></a>
             <div ref={popupRef} tabIndex={-1} role='dialog' aria-live="polite" className={`ui fluid popup right center transition ${PmModuleStyle.ui} ${PmModuleStyle.fluid} ${PmModuleStyle.popup}`} style={{ display: isToggled ? "block" : "none" }} onKeyDown={handleKeyDown}>
                <ul className={`${PmModuleStyle["popup-goal"]}`} role="list">
                  <li role="listitem">
                    <span>Projected Cost</span>
                    <span>
                      <strong>
                        ${formatNum(projectedProjectCost)}
                      </strong>
                    </span>
                  </li>
                  <li role="listitem">
                    <span>Available Budget</span>
                    <span>
                      <strong>
                        ${formatNum(constructionBudget)}
                      </strong>
                    </span>
                  </li>
                </ul>
              </div>
          </div>
          {/* <p className={`${PmModuleStyle['pl-amt']}`} ><strong>${formatNum(simObj?.laststate?.projectedProjectCost)}</strong></p>
          <p className={`${PmModuleStyle["fs-12"]}`}>(Under budget by ${formatNum(simObj?.laststate?.projectedProfitValue)})</p>
          <p className={`${PmModuleStyle["fs-12"]} ${PmModuleStyle["margin-txt"]}`}>Margin</p> */}
           <p className={`${PmModuleStyle['pl-amt']}`} style={{ "color": ((costParameters?.profitPercentage ? costParameters?.profitPercentage : 0) < simObj?.laststate?.profitPercentage) ? '#B90000' :  '#156815' }}><strong>${formatNum(costParameters?.projectProfit ? costParameters?.projectProfit : 0)}  ({costParameters?.profitPercentage ? costParameters?.profitPercentage : 0}%)</strong></p>
          <div className={`quarter-progress`}>
            <div className={`${PmModuleStyle.progress}`} role="progressbar"
              aria-valuenow={progressbar.valuenow()}
              aria-valuemin={progressbar.valuemin}
              aria-valuemax={progressbar.valuemax} 
              aria-valuetext={`${progressbar.valuenow()}%`}>
              <div className={`background`} id={`${PmModuleStyle.profitLoss}`}>
                <div className={`${PmModuleStyle['progress-fg']}`} style={{ "width": progressbar.valuenow() + "%", backgroundColor: ((costParameters?.projectProfit  ?  costParameters?.projectProfit : 0) > simObj?.laststate?.constructionBudget*(simObj?.laststate?.profitPercentage/100) ? '#008638' : '#B90000') }}></div>
              </div>
            </div>
          </div>
          <div className={`${PmModuleStyle["margin-line"]}`}>
            <div>-20K</div>
            <div>10K</div>
            <div>40K</div>
            <div>70K</div>
           </div> 
        </div>
      </div>
    </div>
  )
}

export default CalProfitLoss